import { render, staticRenderFns } from "./MinAvailableStudentAgeForm.vue?vue&type=template&id=7908c17b&scoped=true&"
import script from "./MinAvailableStudentAgeForm.vue?vue&type=script&lang=js&"
export * from "./MinAvailableStudentAgeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908c17b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
